// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"ProfilePage_emptyWrapper__zLakm","emptyText":"ProfilePage_emptyText__xHYUu"};